import React, { Component } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Popover,
  PopoverHeader,
  PopoverBody,
} from "reactstrap";
import { withRouter, Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

// users
import settingIcon from "../../../assets/img/setting-icon.png";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { post } from "helpers/api_helper";
import { connect } from "react-redux";
import { API_URL } from "helpers/api_url";
import { toast } from "react-toastify";

const getUserName = () => {
  if (localStorage.getItem("authUser")) {
    const obj = JSON.parse(localStorage.getItem("authUser"))
    return obj;
  }
}

class ProfileMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menu: false,
      name: "Admin",
      passwordStrength: {
        length: false,
        uppercase: false,
        lowercase: false,
        number: false,
        special: false,
      },
      passwordHintPopoverOpen: false,
      passwordHintPopoverHoverTimeout: null,
    }
    this.toggle = this.toggle.bind(this)
    this.toggleChangePass = this.toggleChangePass.bind(this);
  }

  passwordHintPopoverShow = () => {
    if (this.state.passwordHintPopoverHoverTimeout) {
      clearTimeout(this.state.passwordHintPopoverHoverTimeout);
      this.setState({ passwordHintPopoverHoverTimeout: null });
    }
    this.setState({ passwordHintPopoverOpen: true });
  };

  passwordHintPopoverHide = () => {
    const timeout = setTimeout(() => {
      this.setState({ passwordHintPopoverOpen: false, passwordHintPopoverHoverTimeout: null });
    }, 100);
    this.setState({ passwordHintPopoverHoverTimeout: timeout });
  };

  checkPasswordStrength = (password) => {
    return {
      length: (password || '').length >= 12,
      uppercase: /[A-Z]/.test(password || ''),
      lowercase: /[a-z]/.test(password || ''),
      number: /[0-9]/.test(password || ''),
      special: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password || ''),
    };
  };

  handlePasswordChange = (e, setFieldValue) => {
    const password = e.target.value;
    this.setState({ passwordStrength: this.checkPasswordStrength(password) });
    setFieldValue('newPassword', password);
  };

  toggle() {
    this.setState(prevState => ({
      menu: !prevState.menu,
    }))
  }

  componentDidMount() {
    const userData = getUserName();
    if (userData) {
      this.setState({ name: userData.username })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.success !== this.props.success) {
      const userData = getUserName();
      if (userData) {
        this.setState({ name: userData.username })
      }
    }
  }
  toggleChangePass = async () => {
    const willOpen = !this.state.isChangePass;
    this.setState({ isChangePass: willOpen });
    
    // Call API when opening the Offcanvas
    if (willOpen) {
      try {
        const { clientDetail } = this.props;
        const payload = {
          userId: parseInt(localStorage.getItem("userId"), 10) || 0,
          userName: clientDetail?.userLogin?.userName || "",
          token: "",
        };
        await post(`user/changepasswordinit`, payload);
      } catch (error) {
        console.error("Error calling changepasswordinit:", error);
        // Don't show error toast - just log it
      }
    }
  }
  handleSubmit = async (values, { setSubmitting, resetForm }) => {
    toast.loading('Please wait...');
    try {
      const payload = {
        userId: parseInt(localStorage.getItem("userId"), 10),
        userName: values.userName,
        password: values.newPassword,
        oldPassword: values.oldPassword,
      };
      const response = await post(`user/changepassword`, payload);
      if (response.success) {
        toast.dismiss();
        toast.success("Password changed successfully!");
        this.toggleChangePass();
        resetForm();
        this.setState({
          passwordStrength: { length: false, uppercase: false, lowercase: false, number: false, special: false },
        });
      } else {
        toast.dismiss();
        toast.warn(response.data?.validationErrors?.[0] || "Failed to change password");
      }
    } catch (error) {
      console.error(error);
      toast.dismiss();
      toast.error(error.response?.data?.message || "Failed to change password");
    } finally {
      setSubmitting(false);
    }
  };
  render() {
    const { userdetail, clientDetail } = this.props;
    
    const UserAvatarText = ({ firstName, lastName }) => {
  const initials =
    (firstName?.charAt(0) || "").toUpperCase() +
    (lastName?.charAt(0) || "").toUpperCase();

  return (
    <div
      style={{
        backgroundColor: "#03002E",
        color: "#fff",
        borderRadius: "50%",
        width: "36px",
        height: "36px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
        fontSize: "16px",
      }}
    >
      {initials}
    </div>
  );
};
    return (
      <React.Fragment>
       <li className="d-inline-block d-flex align-items-center">
  <h4 className="ms-4 me-4 font-size-15 profile-name mb-0">
    {clientDetail?.firstName + " " + clientDetail?.lastName}
    <span className="text-muted"> Client Portal</span>
  </h4>
</li>
 <Dropdown
          isOpen={this.state.menu}
          toggle={this.toggle}
          className="d-inline-block"
        >
          <DropdownToggle
            className="btn header-item"
            id="page-header-user-dropdown"
            tag="button"
          >
            <img
              className="rounded-circle header-profile-user"
              src={settingIcon}
              alt="Header Avatar"
            />{" "}
            <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
          </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
            <DropdownItem tag="a" onClick={this.toggleChangePass}>
              <i className="bx bx-user font-size-16 align-middle ms-1" />
              {this.props.t("Change Password")}
            </DropdownItem>
          
            <div className="dropdown-divider" />
            <Link to="/logout" className="dropdown-item">
              <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
              <span>{this.props.t("Logout")}</span>
            </Link>
          </DropdownMenu>
        </Dropdown>
        <Offcanvas
          isOpen={this.state.isChangePass}
          direction="end"
          toggle={this.toggleChangePass}
          style={{ width: 600 }}
        >
          <OffcanvasHeader toggle={this.toggleChangePass}>
            Change Password
          </OffcanvasHeader>
          <OffcanvasBody style={{ fontSize: '16px' }}>
            <Formik
              initialValues={{
                userName: clientDetail?.userLogin?.userName || "",
                oldPassword: "",
                newPassword: "",
                confirmPassword: "",
              }}
              validationSchema={Yup.object().shape({
                oldPassword: Yup.string().required("Old password is required"),
                newPassword: Yup.string()
                  .min(12, "New password must be at least 12 characters")
                  .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
                  .matches(/[a-z]/, "Password must contain at least one lowercase letter")
                  .matches(/[0-9]/, "Password must contain at least one number")
                  .matches(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/, "Password must contain at least one special character")
                  .required("New password is required"),
                confirmPassword: Yup.string()
                  .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
                  .required("Confirm your new password"),
              })}
              onSubmit={this.handleSubmit}
            >
              {({ isSubmitting, setFieldValue }) => (
                <Form autoComplete="off">
                  <div className="form-group mb-3">
                    <label htmlFor="profileOldPassword">Old Password</label>
                    <Field
                      type="password"
                      name="oldPassword"
                      id="profileOldPassword"
                      className="form-control"
                      autoComplete="off"
                    />
                    <ErrorMessage name="oldPassword" component="div" className="text-danger small" />
                  </div>

                  <div className="form-group mb-3">
                    <label htmlFor="profileNewPassword" className="d-flex align-items-center">
                      New Password
                      <span
                        className="btn btn-link btn-sm p-0 ms-1 text-muted"
                        style={{ fontSize: '1rem', textDecoration: 'none', cursor: 'pointer', lineHeight: 1 }}
                        onMouseEnter={this.passwordHintPopoverShow}
                        onMouseLeave={this.passwordHintPopoverHide}
                        role="button"
                        tabIndex={0}
                        title="Password requirements"
                      >
                        <i className="mdi mdi-information-outline" aria-hidden="true" />
                      </span>
                    </label>
                    <div id="profilePasswordHintPopoverTarget" style={{ display: 'inline-block', width: '100%' }}>
                      <Field
                        type="password"
                        name="newPassword"
                        id="profileNewPassword"
                        className="form-control"
                        placeholder="Min 12 characters"
                        autoComplete="off"
                        onChange={(e) => this.handlePasswordChange(e, setFieldValue)}
                        onFocus={this.passwordHintPopoverShow}
                        onBlur={this.passwordHintPopoverHide}
                      />
                      <Popover
                        placement="left"
                        isOpen={this.state.passwordHintPopoverOpen}
                        target="profilePasswordHintPopoverTarget"
                        toggle={() => this.setState({ passwordHintPopoverOpen: !this.state.passwordHintPopoverOpen })}
                        style={{ fontSize: '16px' }}
                      >
                        <PopoverHeader style={{ fontSize: '16px' }}>Password Requirements</PopoverHeader>
                        <PopoverBody
                          onMouseEnter={this.passwordHintPopoverShow}
                          onMouseLeave={this.passwordHintPopoverHide}
                          style={{ fontSize: '16px' }}
                        >
                          <div className="password-requirements" style={{ fontSize: '16px' }}>
                            <div className={`d-flex align-items-center mb-1 ${this.state.passwordStrength.length ? 'text-success' : 'text-muted'}`}>
                              <i className={`mdi ${this.state.passwordStrength.length ? 'mdi-check-circle' : 'mdi-circle-outline'} me-2`}></i>
                              <span>Minimum 12 characters</span>
                            </div>
                            <div className={`d-flex align-items-center mb-1 ${this.state.passwordStrength.uppercase ? 'text-success' : 'text-muted'}`}>
                              <i className={`mdi ${this.state.passwordStrength.uppercase ? 'mdi-check-circle' : 'mdi-circle-outline'} me-2`}></i>
                              <span>At least one uppercase letter (A-Z)</span>
                            </div>
                            <div className={`d-flex align-items-center mb-1 ${this.state.passwordStrength.lowercase ? 'text-success' : 'text-muted'}`}>
                              <i className={`mdi ${this.state.passwordStrength.lowercase ? 'mdi-check-circle' : 'mdi-circle-outline'} me-2`}></i>
                              <span>At least one lowercase letter (a-z)</span>
                            </div>
                            <div className={`d-flex align-items-center mb-1 ${this.state.passwordStrength.number ? 'text-success' : 'text-muted'}`}>
                              <i className={`mdi ${this.state.passwordStrength.number ? 'mdi-check-circle' : 'mdi-circle-outline'} me-2`}></i>
                              <span>At least one number (0-9)</span>
                            </div>
                            <div className={`d-flex align-items-center mb-1 ${this.state.passwordStrength.special ? 'text-success' : 'text-muted'}`}>
                              <i className={`mdi ${this.state.passwordStrength.special ? 'mdi-check-circle' : 'mdi-circle-outline'} me-2`}></i>
                              <span>At least one special character (!@#$%^&*...)</span>
                            </div>
                          </div>
                        </PopoverBody>
                      </Popover>
                    </div>
                    <ErrorMessage name="newPassword" component="div" className="text-danger small" />
                  </div>

                  <div className="form-group mb-3">
                    <label htmlFor="profileConfirmPassword">Confirm New Password</label>
                    <Field
                      type="password"
                      name="confirmPassword"
                      id="profileConfirmPassword"
                      className="form-control"
                      autoComplete="off"
                    />
                    <ErrorMessage name="confirmPassword" component="div" className="text-danger small" />
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary w-100"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Changing..." : "Change Password"}
                  </button>
                </Form>
              )}
            </Formik>
          </OffcanvasBody>
        </Offcanvas>
      </React.Fragment>
    )
  }
}

ProfileMenu.propTypes = {
  t: PropTypes.any,
  success: PropTypes.string,
  userdetail:PropTypes.object,
  clientDetail:PropTypes.object
}

const mapStateToProps = state => {
  
}

export default withRouter(
  connect()(withTranslation()(ProfileMenu))
)
